import React from 'react';
import { PriceSubHeaderContainer } from '../style';
import StyledDatePicker from 'components/DatePicker';
import colors from 'constants/colors';
import moment from 'moment-timezone';
import { TIME_ZONE } from 'constants/constant';

const SubHeader = ({ checkInDate, checkOutDate, setCheckInDate, setCheckOutDate }) => {
  return (
    <PriceSubHeaderContainer>
      <div className="datePickerContainer">
        <div className="datePicker">
          <StyledDatePicker
            dateValue={moment(checkInDate).tz(TIME_ZONE)}
            dateOnChange={setCheckInDate}
            variant="standard"
            placeholder="Select start date"
            additionalstyle={`
              width: 137px;

              input{
                font-weight: 400;
                padding-right: 26px;
                border-bottom: 2px solid ${colors.darkGrey};
              }

              .MuiInput-root {
                margin-top: 0;
              }
            `}
          />
        </div>
        <div className="datePicker">
          <StyledDatePicker
            dateValue={moment(checkOutDate).tz(TIME_ZONE)}
            dateOnChange={setCheckOutDate}
            variant="standard"
            placeholder="Select end date"
            additionalstyle={`
              width: 137px;

              input{
                font-weight: 400;
                padding-right: 26px;
                border-bottom: 2px solid ${colors.darkGrey};
              }

              .MuiInput-root {
                margin-top: 0;
              }
            `}
          />
        </div>
      </div>
    </PriceSubHeaderContainer>
  );
};

export default SubHeader;
